import React from 'react'
import styled from 'styled-components'

import Section from 'components/Section'

const PanelWrapper = styled.div`
  position: relative;
`

const Panel: React.FC = ({ children }) => {
  return <PanelWrapper>{children}</PanelWrapper>
}

interface PanelTitleProps {
  extra?: React.ReactNode
}

export const PanelTitle: React.FC<PanelTitleProps> = ({ extra, children }) => (
  <Section title={children} action={extra} />
)

export const PanelBody = styled.div`
  color: ${({ theme }) => theme.colors.foreground.secondary[3]};
  font-size: ${({ theme }) => theme.fontSizes.smaller};
  line-height: 1.5;
`

export default Panel
